import { useState } from "react";
import IconChevron from "@/assets/icons/chevron.svg?react";
import { useTranslation } from "react-i18next";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";
import clsx from "clsx";

interface Props {
  className?: string;
  text: string;
}

export default function ExpandableText({ className, text }: Props) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={className}>
      <p
        className={clsx(
          "relative text-white text-sm leading-[1.4]",
          !expanded && "line-clamp-4"
        )}
        style={{ wordBreak: "break-word" }}
      >
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </p>

      {/* Show button only if text overflows (optional: always show for now) */}
      <VibratingButton
        className="bg-clip-text text-transparent bg-yellow-linear mt-1 inline-flex items-center gap-0.5"
        onClick={() => setExpanded((prev) => !prev)}
      >
        {expanded ? t("less") : t("more")}
        <IconChevron
          width="16"
          height="16"
          className={`${
            expanded ? "rotate-[270deg]" : "rotate-90"
          } text-[#ECA438] transition-transform duration-300`}
          strokeWidth="1.5"
        />
      </VibratingButton>
    </div>
  );
}